import _ from 'underscore';
import Promise from 'bluebird';
import { loadScriptAsynchronously } from '@bingads-webui-campaign-react/smart-component-util';

export const DEFAULT_BING_MAP_API_KEY = 'AgRuCtepgsuuCYV9J6S6w1j8ay2JJwnu8f5EPgv4kkoJoIuka8yui-NzKrvlESTQ';

// Default location: One Microsoft Way, Redmond, WA 98052
export const DEFAULT_GEO_LOCATION = {
  latitude: 47.64,
  longitude: -122.13,
};

export const injectScript = (logger) => {
  const sdkSrc = 'https://www.bing.com/api/maps/mapcontrol';
  const sdkId = 'Bing-map-sdk';

  return loadScriptAsynchronously({
    id: sdkId,
    src: sdkSrc,
    logger,
  });
};

export const getBingMapsSdk = () => {
  const { Microsoft } = window;

  if (_.isUndefined(Microsoft)
    || _.isUndefined(Microsoft.Maps)
    || _.isUndefined(Microsoft.Maps.Color)
    || _.isUndefined(Microsoft.Maps.loadModule)) {
    return null;
  }

  return Microsoft.Maps;
};

/**
 * Poll until the Bing Maps SDK is available on this page.
 * @param {Number} [maxAttempts=10] - Max number of attempts.
 * @param {Number} [interval=100] - Time in ms to wait between attempts.
 * @param {Number} [currentAttempts=0] - Current number of attempts.
 * @returns {Promise} - Promise that resolves to the Bing Maps SDK or null if it failed to load.
 */
export const pollForBingMapsSdk = (maxAttempts = 10, interval = 100, currentAttempts = 0) => {
  const sdk = getBingMapsSdk();
  if (!sdk) {
    if (currentAttempts >= maxAttempts) {
      // reached max attempts
      return Promise.resolve(null);
    }

    // delay and then poll again
    return Promise.delay(interval)
      .then(() => pollForBingMapsSdk(maxAttempts, interval, currentAttempts + 1));
  }

  return Promise.resolve(sdk);
};

